import { render, staticRenderFns } from "./userInfoProperti.vue?vue&type=template&id=1fc94cc8&"
import script from "./userInfoProperti.vue?vue&type=script&lang=ts&"
export * from "./userInfoProperti.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports